<div class="container">
    <div class="row trackerAccordion">
        <div class="col-sm-12 col-md-12 col-lg-12 mt-3 p-0 bg-white notification-box">

            <div id="notification-header" class="p-3">
                <div class="row align-items-center">
                    <div class="col-9 font18" translate>
                        lblAllNotifications
                    </div>
                    <div class="col-3">
                        <div class="input-group">
                            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="notificationRequestModel.searchTerm" autocomplete="off" (keyup.enter)="GetNotifications()" />
                            <div class="input-group-append">
                                <button type="button" id="btnsearch" class="btn btn-primary" (click)="GetNotifications()" aria-label="Center Align">
                                    <em class="fa fa-search" aria-hidden="true"></em>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <div class="table-responsive max-h357" *ngIf="notificationList" infinite-scroll
                [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false"
                [alwaysCallback]="true" (scrolled)="onScrollDown($event)">
                <div *ngFor="let notification of notificationList; let i = index">
                    <div class="p-2 btm-border" [ngClass]="notification.isRead ? 'bg-highlight-n' : ''" (click)="viewNotification(notification)">
                        <div class="row mx-1 justify-content-between">
                            <div>
                                <p class="msg-header" [ngClass]="notification.isRead ? 'fontnormal':'font-weight-bold' ">
                                    {{notification.subject}}</p>
                            </div>
                            <div>
                                <p class="msg-date">{{notification.timeAgo}}</p>
                            </div>
                        </div>

                        <div class="mx-1">
                            <p class="msg-subject" [innerHTML]="notification.content"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-sm-row flex-column justify-content-end">
                <button class="btn btn-primary mr-sm-2 btn-lg" (click)="moveBack();"><span translate>lblBack</span>
                </button>
            </div>
        </div>
    </div>
</div>